
import { computed, defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { DispatcherDeliveryListOrderT } from '@/core/types/dispatcher.types'

// enums
import { DispatcherOrderStatusesEnum } from '@/core/enums/dispatcher.enums'

// realisations
import { dispatcher } from '@/core/realisations/dispatcher.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        'the-button': TheButton,
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<DispatcherDeliveryListOrderT>,
            required: true,
        },
    },
    emits: ['item-removed', 'delivery', 'delivery-with-verify', 'date', 'closed'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const remove = async () => {
            const answer = confirm(
                `Вы действительно хотите удалить доставку заказа (id: ${props.item.id})?`
            )
            if (!answer) return

            try {
                state.is_loading = true

                await dispatcher.deleteDelivery(props.item.id)

                notifications.notify({
                    title: `Доставка заказа (ID: ${props.item.id}) удалена`,
                    type: 'success',
                })

                emit('item-removed', props.item.id)
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: `При удалении доставки заказа ${props.item.id} произошла ошибка`,
                })
            } finally {
                state.is_loading = false
            }
        }

        const emitDelivery = () => {
            emit('delivery', { ...props.item })
        }

        const emitDeliveryWithVerify = () => {
            emit('delivery-with-verify', { ...props.item })
        }

        const emitManager = () => {
            if (props.item.verify) {
                emitDeliveryWithVerify()
                return
            }

            emitDelivery()
        }

        const emitDate = () => {
            emit('date', { ...props.item })
        }

        const close = async () => {
            const answer = confirm(
                `Вы действительно хотите закрыть ДК заказа (id: ${props.item.id})?`
            )
            if (!answer) return

            try {
                state.is_loading = true

                await dispatcher.closeDelivery(props.item.id)

                notifications.notify({
                    title: `ДК заказа (ID: ${props.item.id}) закрыта`,
                    type: 'success',
                })
                emit('closed')
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: `При закрытии ДК заказа ${props.item.id} произошла ошибка`,
                })
            } finally {
                state.is_loading = false
            }
        }

        //

        const isCanApproveDelivery = computed(() => {
            if (props.item.status === 'not_delivered') {
                return true
            }

            return false
        })

        const isCanChangeDate = computed(() => props.item.isDeliveryDateChangeable)

        const isCanClose = computed(() => props.item.isPickup)

        return {
            DispatcherOrderStatusesEnum,
            state,
            remove,
            close,
            emitManager,
            emitDate,
            //
            isCanApproveDelivery,
            isCanChangeDate,
            isCanClose,
        }
    },
})
